import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const FullscreenExit = ({ color, ...rest }) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 160 160' {...rest}>
    <g>
      <title>background</title>
      <rect fill='none' id='canvas_background' height='402' width='582' y='-1' x='-1' />
    </g>
    <g>
      <title>Layer 1</title>
      <g style={{ display: 'none' }} id='Layer_2_1_'>
        <rect id='svg_1' height='360' width='360' style={{ display: 'inline' }} y='-100' x='-100' />
      </g>
      <polyline id='svg_2' points='69.06,91.85 16.94,147.02 13.89,150.27 11.14,153.17 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <polyline id='svg_3' points='128.13913667201996,72.27453672885895 87.87913453578949,72.27453672885895 85.13913667201996,72.27453672885895 85.13913667201996,66.17453062534332 85.13913667201996,26.274536728858948 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <line id='svg_4' y2='91.85' x2='69.06' y1='147.02' x1='16.94' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <polyline id='svg_5' points='90.62,67.28 142.74,12.1 145.79,8.86 148.53,6 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <line id='svg_7' y2='67.28' x2='90.62' y1='12.1' x1='142.74' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <polyline id='svg_8' points='69.06,91.85 16.94,147.02 13.89,150.27 11.14,153.17 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <line id='svg_9' y2='91.85' x2='69.06' y1='147.02' x1='16.94' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <polyline id='svg_10' points='90.62,67.28 142.74,12.1 145.79,8.86 148.53,6 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <polyline id='svg_11' points='32.895363450050354,85.31163692474365 73.15535795688629,85.31163692474365 75.89536345005035,85.31163692474365 75.89536345005035,91.41163539886475 75.89536345005035,131.31162929534912 ' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
      <line id='svg_12' y2='67.28' x2='90.62' y1='12.1' x1='142.74' fill='none' stroke={color} strokeWidth='10' strokeLinecap='round' strokeLinejoin='round' />
    </g>
  </svg>
)
/* --------------------------------------------- */
FullscreenExit.propTypes = {
  /** Color of icon. */
  color: PropTypes.string,
  /** Icon css styles. */
  style: PropTypes.object
}
/* --------------------------------------------- */
FullscreenExit.defaultProps = {
  color: 'transparent',
  style: {
    width: 35,
    height: 35
  }
}
/* --------------------------------------------- */
export default FullscreenExit
/* --------------------------------------------- */
